//DNA
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

//MBK Custom mudule
import CollectPointByAdmin from "@/constants/navigation/BOYNYKJMS2EH/menu/collect-point-by-admin";
import collectPointByCounter from "@/constants/navigation/BOYNYKJMS2EH/menu/collect-point-by-counter";
import customerManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/customer-management";
import merchantManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/merchant-management";
import pointManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/point-management";
import adjustPoint from "@/constants/navigation/BOYNYKJMS2EH/menu/adjust-point";
import collectPointByConcierge from "@/constants/navigation/BOYNYKJMS2EH/menu/collect-point-by-concierge";
//only dev
import mission from "@/constants/navigation/BOYNYKJMS2EH/menu/mission";
import userManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/user-management";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVL68aBitVW30j": // Prod MBK BO EP Collect-Point-Admin
    case "PVty84kVK6FfAL": // dev MBK BO EP Collect-Point-Admin
      switch (decodeToken()?.sub) {
        case "ID_Jr9mgxweQmxF": //prod admin01@mbkgroup.co.th
        case "ID_3NCHw54wGtCo": //prod train02@mbkgroup.co.th
        case "ID_WxqCmm0qeyYz": //prod train03@mbkgroup.co.th

        case "ID_aTKXDsLNQkVG": // dev train02@mbkgroup.co.th
          return [...CollectPointByAdmin];
      }
    case "PVgLxrFY6Gq88c": // Prod MBK BO EP Collect-Point-Counter
    case "PVzPEzK49kHzgG": // dev MBK BO EP Collect-Point-Counter
      switch (decodeToken()?.sub) {
        case "ID_rquB6txeB5hD": //prod counter01@mbkgroup.co.th
        case "ID_U75JSSJJ7ZSV": //prod digitalmkt@mbk-center.co.th
        case "ID_FsZ0vNBkdnZ5": //prod thaniyapha@icam.co.th
        case "ID_BaQ6TTRLZ3gZ": //prod kidtima@icam.co.th
        case "ID_HiZqD2c5FbZW": //prod punyisab@paradisepark.co.th
        case "ID_ALH50i4vkPL4": //prod paveena@icam.co.th
        case "ID_MHRL9AvqoZWa": //prod apinya@icam.co.th
        case "ID_ta6rDOIQc2wG": //prod natwara@paradisepark.co.th
        case "ID_SBALxgMRTqTV": //prod piyapornl@paradisepark.co.th
        case "ID_h9zx2ENGJmOm": //prod jaruta@paradisepark.co.th
        case "ID_U6Zncj1igMns": //prod wipawee@paradisepark.co.th
        case "ID_L5p461kd77Cp": //prod natchan@icam.co.th
        case "ID_oPA0KRnrK7nZ": //prod pitukan@icam.co.th
        case "ID_UUl44LD2ogF2": //prod rattikan@icam.co.th
        case "ID_sSdQhiPPpsTI": //prod anuwat@icam.co.th
        case "ID_YOlE61klFKhi": //prod nuankhae@icam.co.th
        case "ID_HciO3q83w2pi": //prod janyaporn@icam.co.th
        case "ID_mo8iBLzJ6KJ8": //prod intratip@icam.co.th
        case "ID_1nNAPbr5Gyfl": //prod jiraporns@icam.co.th
        case "ID_zkhizQBQx2FT": //prod hassanai@icam.co.th
        case "ID_ZUkN815Icz6N": //prod aruneeb@icam.co.th
        case "ID_OPF8TQO9yxMA": //prod pikul@icam.co.th
        case "ID_CKeRC20k3ywq": //prod nattaphol@icam.co.th
        case "ID_DqeuV9Hoyhin": //prod train03@mbkgroup.co.th
        case "ID_cqLQfwcS7A6x": //prod pannathad@icam.co.th

        case "ID_KbOOJ0DrLbqz": //dev train03@mbkgroup.co.th
          return [...collectPointByCounter];
      }
    case "PVXt53P954FAM5": // Prod MBK BO EP callcenter-external
    case "PV77W0yn992sSH": // dev MBK BO EP callcenter-external
      switch (decodeToken()?.sub) {
        case "ID_aXsfwL2oBIR3": //prod callcenter01@mbkgroup.co.th
        case "ID_EvPBJKOLnizn": //prod train04@mbkgroup.co.th

        case "ID_rQyZZcgjlzxt": //dev train04@mbkgroup.co.th
          return [...customerManagement];
      }
    case "PVJixJMQ2F66RE": // Prod MBK BO EP Customer Management
      switch (decodeToken()?.sub) {
        case "ID_G4OUdiwC5vva": //prod train04@mbkgroup.co.th
          return [...customerManagement];
      }
    default:
      return [
        //prod
        ...inventory,
        ...privileges,
        ...banner,
        ...survey,
        ...fulfillment,
        ...tags,
        ...report,
        ...customerManagement,
        ...merchantManagement,
        // ...pointManagement, //only dev
        // ...adjustPoint, //only dev
        ...article,
        ...CollectPointByAdmin,
        ...collectPointByCounter, //only prod
        // ...collectPointByConcierge, //only dev
        ...adjustPoint, // only prod
        // ...mission, //only dev
        // ...userManagement, //only dev
      ];
  }
};

export default renderNavByPermission();
